let user = localStorage.getItem('user')
export default {
    APP_ID: 'wx98901a0d7835b3a1',
    user: user?JSON.parse(user):user,
    isWeixin(){
        var ua = navigator.userAgent.toLowerCase();
        var isWeixin = ua.indexOf('micromessenger') > 0;
        if (isWeixin) {
            return true;
        }else{
            return false;
        }
    },
    isLeapYear(year){
        if(year%400 === 0 || (year%4 === 0 && year%100 !== 0) ) {
            return true;
        }else{
            return false;
        }
    },
    getMonthDays(year,month){
        switch(month){
            case 1:
            case 3:
            case 5:
            case 7:
            case 8:
            case 10:
            case 12:
                return 31;
                break;
            case 4:
            case 6:
            case 9:
            case 11:
                return 30;
                break;
            case 2:
                if(this.isLeapYear(year)){
                    return 29;
                }else{
                    return 28;
                }
                break;
        }
    },
    formatDate(date,format){ 
        var o = { 
            "M+" : date.getMonth()+1, //month 
            "d+" : date.getDate(), //day 
            "h+" : date.getHours(), //hour 
            "m+" : date.getMinutes(), //minute 
            "s+" : date.getSeconds(), //second 
            "q+" : Math.floor((date.getMonth()+3)/3), //quarter 
            "S" : date.getMilliseconds() //millisecond 
        } 
        
        if(/(y+)/.test(format)) { 
            format = format.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 
        } 
        
        for(var k in o) { 
            if(new RegExp("("+ k +")").test(format)) { 
                format = format.replace(RegExp.$1, RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length)); 
            } 
        } 
        return format; 
    },
    goLogin(goUrl){
        localStorage.removeItem('token');
        localStorage.removeItem('userMobile');
        localStorage.removeItem('user');
        goUrl = goUrl || vue.$route.path;
        localStorage.setItem('goUrl',goUrl);
        if(this.isWeixin()){
            let initLoginPage = location.origin+'/initLogin';
            location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid='+ this.APP_ID +'&redirect_uri='+ initLoginPage +'&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
        }else{
            vue.$router.push({
                name: 'login'
            })
        }
    },
    toThousands(num) {
        return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    },
    configWX(){
        if(this.isWeixin()){
            vue.$api.post({
                url: '/api/pay/config.do',
                success: res=>{
                    let config = res.config;
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: config.appId, // 必填，公众号的唯一标识
                        timestamp: config.timestamp, // 必填，生成签名的时间戳
                        nonceStr: config.nonceStr, // 必填，生成签名的随机串
                        signature: config.signature,// 必填，签名，见附录1
                        jsApiList: ['getLocation','chooseWXPay']
                    });
                }
            });
        }else{

        }
        
    },
    configWXShare(title,desc,link,imgUrl,type,id,from,isappinstalled){
        if(this.isWeixin()){
            var requestUrl  = "/api/conferenceRoom/shareUrl.do?type="+type;
            if(id){
                requestUrl = requestUrl+"&id="+id;
            }
            if(from){
                requestUrl = requestUrl + "&from="+from;
            }
            if(isappinstalled){
                requestUrl = requestUrl + "&isappinstalled="+isappinstalled;
            }

            vue.$api.post({
                url: requestUrl,
                success: res=>{
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: res.appId, // 必填，公众号的唯一标识
                        timestamp: res.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.nonceStr, // 必填，生成签名的随机串
                        signature: res.signature,// 必填，签名，见附录1
                        jsApiList:[
                            'onMenuShareTimeline',
                            'onMenuShareAppMessage',
                            'onMenuShareQQ',
                            'onMenuShareWeibo',
                            'onMenuShareQZone'
                          ]
                    });

                    wx.ready(function () { 
                        //分享给朋友
                        wx.onMenuShareAppMessage({
                            title: title,
                            desc: desc,
                            link: link,
                            imgUrl: imgUrl,
                            success: function () { 
                            
                            }
                        });
                        //分享到朋友圈
                        wx.onMenuShareTimeline({
                            title: title,
                            desc: desc,
                            link: link,
                            imgUrl: imgUrl,
                            success: function () { 
                            
                            }
                        });
                        //分享到QQ
                        wx.onMenuShareQQ({
                            title: title,
                            desc: desc,
                            link: link,
                            imgUrl: imgUrl,
                            success: function () { 
                            
                            }
                        });
                        //分享到腾讯微博
                        wx.onMenuShareWeibo({
                            title: title,
                            desc: desc,
                            link: link,
                            imgUrl: imgUrl,
                            success: function () { 
                            
                            }
                        });
                        //分享到QQ空间
                        wx.onMenuShareQZone({
                            title: title,
                            desc: desc,
                            link: link,
                            imgUrl: imgUrl,
                            success: function () { 
                            
                            }
                        });
        
                        wx.error(function(res){
                            alert(res);
                        });
                    });
                   
                }
            });
        }else{

        }
        
    },
    pay(targetId,bizType,url){
        var promise = new Promise((resolve,reject)=>{
            if(this.isWeixin()){
                vue.$api.post({
                    url: '/api/pay/weiXinPay.do',
                    data: {
                        targetId: targetId,
                        bizType: bizType
                    },
                    success: res=>{
                        if(res.isFree == '1'){
                            resolve();
                        }else{
                            wx.ready(function(){
                                wx.chooseWXPay({
                                    timestamp: res.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                                    nonceStr: res.nonceStr, // 支付签名随机串，不长于 32 位
                                    package: res.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                                    signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                                    paySign: res.paySign, // 支付签名
                                    success: (resp) => {
                                        if(resp.errMsg=="chooseWXPay:ok"){
                                            resolve();
                                        }
                                    },
                                    cancel: (resp) => {
                                        reject();
                                    },
                                    error: (resp) => {
                                        reject();
                                    }
                                });
                            });
                        }
                    },
                    fail: res=>{
                        reject();
                    }
                });
            }else{
                vue.$api.post({
                    url: '/api/pay/weiXinPay.do',
                    data: {
                        targetId: targetId,
                        bizType: bizType,
                        isH5: 1
                    },
                    success: res=>{
                        // vue.$messagebox.confirm('请确认微信支付是否完成',{
                        //     confirmButtonText: '已完成',
                        //     cancelButtonText: '重新支付 '
                        // }).then(action=>{
                        //     if(action==='confirm'){
                        //         location.reload();
                        //     }else{
                        //         this.pay(targetId,bizType,url);
                        //     }
                        // })
                        location.href=res.url+'&redirect_url=' + encodeURI(url);
                    },
                    fail: res=>{
                        vue.$messagebox.alert(res);
                        reject();
                    }
                });
            }
        });
        return promise;
    }
}


// WEBPACK FOOTER //
// ./src/util.js